export const FavoriteContact = ({
  classes,
  contacts,
  value,
  setSelected,
  setSelectAll,
  setSelectAllCS,
}) => {
  const getFicheContactEmail = () => {
    return value.cs_email_contact
  }
  const getContactsMethodPreference = (preferenceContact = null) => {
    switch (preferenceContact) {
      case 1:
        return 'Membres individuels uniquement'

      case 2:
        return getFicheContactEmail()

      case 3:
        return 'Les deux (membres individuels et CS)'

      default:
        return 'Aucune préférence'
    }
  }
  return (
    <div className={classes.contactPreferenceWrapper}>
      Préférence de contact du CS renseigné dans la fiche immeuble :
      <div
        onClick={() => {
          const csMembers = contacts.reduce((acc, item) => {
            if (item.roles?.includes('CS Member')) {
              acc.push(item.email)
            }
            return acc
          }, [])
          switch (value.cs_contact_preference) {
            case 1:
              setSelected(csMembers)
              setSelectAllCS(true)
              setSelectAll(false)
              break
            case 2:
              setSelected([value.cs_email_contact])
              setSelectAllCS(false)
              setSelectAll(false)
              break
            case 3:
              setSelected([
                ...csMembers.filter((item) => item !== value.cs_email_contact),
                value.cs_email_contact,
              ])
              setSelectAllCS(true)
              setSelectAll(false)
              break
            default:
              setSelected(csMembers)
          }
        }}
        className={classes.contactPreference}
      >
        {getContactsMethodPreference(value.cs_contact_preference)}
      </div>
    </div>
  )
}
